import { no_propagate } from "./utils";

const HammockDiaryLink = ({ url }) => {

  if (url === "") {
    return null;
  }

  const url_with_word_break_elements = url.replaceAll("/", "​/​")

  return (
    <div className="hammock_diary">
      <a href={url} target="_blank" rel="noreferrer"
         onClick={no_propagate}>
        {url_with_word_break_elements}
      </a>
    </div>
  );
};

export default HammockDiaryLink;
